import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  scrollView: {
    paddingBottom: 24,
    paddingHorizontal: 16,
  },
  containerToolOptions: {
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: 2.5,
    rowGap: 12,
  },
});
